import VeeValidate from 'vee-validate';

VeeValidate.Validator.extend('char_name', (value) => value.search(/^[a-zA-Z0-9\-_\.]+$/) >= 0);

VeeValidate.Validator.extend('repeat_password', (value, [other]) => value === other, {
    hasTarget: true
});

export default VeeValidate;